export const getRole = (role) => {
  if (role === 'company-admin') return 'Admin';
  if (role === 'company-manager') return 'Manager';
  return 'Member';
};
